import React from 'react';
import { Link } from 'react-router-dom';
import { Eye, ArrowRight, Leaf } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { formatPrice, formatDateTime, ORDER_STATUS } from '../../lib/utils';

export const RecentOrdersCard = ({ recentOrders, onStatusChange }) => {
    return (
        <Card className="border-0 bg-white/80 backdrop-blur-sm shadow-sm rounded-2xl">
            <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle className="font-heading text-jungle">Commandes recentes</CardTitle>
                <Button asChild variant="ghost" size="sm" className="text-leaf hover:text-leaf hover:bg-leaf/10">
                    <Link to="/admin/commandes">
                        Voir tout
                        <ArrowRight className="h-4 w-4 ml-2" />
                    </Link>
                </Button>
            </CardHeader>
            <CardContent>
                {recentOrders?.length > 0 ? (
                    <div className="overflow-x-auto">
                        <Table>
                            <TableHeader>
                                <TableRow className="border-jungle/10">
                                    <TableHead className="text-jungle/70">N° Commande</TableHead>
                                    <TableHead className="text-jungle/70">Client</TableHead>
                                    <TableHead className="text-jungle/70">Date</TableHead>
                                    <TableHead className="text-jungle/70">Total</TableHead>
                                    <TableHead className="text-jungle/70">Statut</TableHead>
                                    <TableHead></TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {recentOrders.map((order) => (
                                    <TableRow key={order.id} className="border-jungle/10" data-testid={`admin-order-${order.id}`}>
                                        <TableCell className="font-medium text-jungle">{order.order_number}</TableCell>
                                        <TableCell className="text-muted-foreground">{order.company_name}</TableCell>
                                        <TableCell className="text-muted-foreground">{formatDateTime(order.created_at)}</TableCell>
                                        <TableCell className="font-semibold text-leaf">{formatPrice(order.total)}</TableCell>
                                        <TableCell>
                                            <Select
                                                value={order.status}
                                                onValueChange={(value) => onStatusChange(order.id, value)}
                                            >
                                                <SelectTrigger className="w-[140px] border-jungle/20 rounded-xl" data-testid={`status-select-${order.id}`}>
                                                    <SelectValue />
                                                </SelectTrigger>
                                                <SelectContent className="bg-white/95 backdrop-blur-xl">
                                                    {Object.entries(ORDER_STATUS).map(([key, { label }]) => (
                                                        <SelectItem key={key} value={key}>{label}</SelectItem>
                                                    ))}
                                                </SelectContent>
                                            </Select>
                                        </TableCell>
                                        <TableCell>
                                            <Button asChild variant="ghost" size="sm" className="hover:bg-leaf/10">
                                                <Link to={`/admin/commande/${order.id}`}>
                                                    <Eye className="h-4 w-4 text-leaf" />
                                                </Link>
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                ) : (
                    <div className="text-center py-8 text-muted-foreground">
                        <Leaf className="w-12 h-12 mx-auto mb-4 text-jungle/20" />
                        Aucune commande
                    </div>
                )}
            </CardContent>
        </Card>
    );
};
